/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  makeStyles,
  OutlinedInput,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tabs,
  CircularProgress,
} from '@material-ui/core';
import ApplicationState from 'store/interfaces';
import Button from 'components/Button';
import { getAlarmsInstanceRequest } from 'modules/environments/actions';
import { cyrb53Hash, formatDateWithMoment } from 'utils/helpers';
import { connect } from 'react-redux';
import SearchIcon from '@material-ui/icons/Search';
import i18n from 'i18n';
import React from 'react';
import { AlarmsInstanceDataProps } from 'modules/environments/interfaces';
import clsx from 'clsx';
import { CompanyData, RolesEnum } from 'modules/authenticate/interfaces';
import { inAdminView, inSuperAdminView, inOperatorView } from 'utils/role';
import styles from './styles';
import ScreenStatus from './ScreenStauts';

const useStyles = makeStyles(styles);

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div style={{ minWidth: 750 }} hidden={value !== index} {...other}>
      {value === index && children}
    </div>
  );
}

interface Props {
  environmentId: string;
  role?: RolesEnum;
  companySelected: CompanyData | null;
  instanceId: string;
  alarmsInstanceList: AlarmsInstanceDataProps;
  isLoading: boolean;
  getAlarmsInstanceRequest: ({ id, instanceId }) => void;
  modalClose: () => void;
}

const AlarmesAndLogs = ({
  environmentId,
  role,
  companySelected,
  instanceId,
  alarmsInstanceList,
  isLoading,
  getAlarmsInstanceRequest,
  modalClose,
}: Props) => {
  const classes = useStyles();

  const [searchValue, setSearchValue] = React.useState('');
  const [value, setValue] = React.useState(0);

  React.useEffect(() => {
    getAlarmsInstanceRequest({ id: environmentId, instanceId });
  }, [environmentId, instanceId, getAlarmsInstanceRequest]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        {/* <FormControl variant="outlined" fullWidth>
          <InputLabel>{i18n.t('SEARCH_KEY')}</InputLabel>
          <OutlinedInput
            type="text"
            value={searchValue}
            onChange={({ target }) => setSearchValue(target.value)}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  onClick={() => null}
                  edge="end"
                  disabled={isLoading}
                >
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            }
            labelWidth={70}
          />
        </FormControl> */}
      </Grid>

      <Grid item xs={12} style={{ minHeight: 350 }}>
        <Grid container className={classes.rootTabs}>
          <Tabs
            value={value}
            onChange={(e, newValue) => setValue(newValue)}
            className={clsx({
              [classes.tabsGreen]: inAdminView(role, companySelected),
              [classes.tabsGray]: inSuperAdminView(role, companySelected),
              [classes.tabsBlue]: inOperatorView(role, companySelected),
              [classes.tabsYellow]: companySelected,
            })}
          >
            <Tab
              label={i18n.t('ALARMS_KEY')}
              className={clsx({
                [classes.tabGreen]: inAdminView(role, companySelected),
                [classes.tabGray]: inSuperAdminView(role, companySelected),
                [classes.tabBlue]: inOperatorView(role, companySelected),
                [classes.tabYellow]: companySelected,
              })}
            />
            <Tab
              label={i18n.t('LOGS_KEY')}
              className={clsx({
                [classes.tabGreen]: inAdminView(role, companySelected),
                [classes.tabGray]: inSuperAdminView(role, companySelected),
                [classes.tabBlue]: inOperatorView(role, companySelected),
                [classes.tabYellow]: companySelected,
              })}
            />
          </Tabs>
        </Grid>

        <TabPanel value={value} index={0}>
          {isLoading ? (
            <Grid
              container
              className={classes.loadingContainer}
              alignItems="center"
              justify="center"
            >
              <CircularProgress size={30} color="primary" />
            </Grid>
          ) : (
            <Table size="small" className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell>{i18n.t('TIME_KEY')}</TableCell>
                  <TableCell>{i18n.t('STATUS_KEY')}</TableCell>
                  <TableCell>{i18n.t('MESSAGE_KEY')}</TableCell>
                  <TableCell>{i18n.t('MODIFIED_BY_KEY')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {alarmsInstanceList.count === 0 ? (
                  <TableRow>
                    <TableCell align="center" colSpan={4}>
                      {i18n.t('ENVIRONMENTS_PAGE.ALARMS_INSTANCE_NOT_FOUND')}
                    </TableCell>
                  </TableRow>
                ) : (
                  <>
                    {alarmsInstanceList.results.map(item => (
                      <TableRow key={cyrb53Hash(item?.operator)}>
                        <TableCell key={item?.creation_date}>
                          {formatDateWithMoment(item?.creation_date)}
                        </TableCell>
                        <TableCell>
                          <ScreenStatus type={item?.status} />
                        </TableCell>
                        <TableCell>{item?.message}</TableCell>
                        <TableCell>{item?.operator}</TableCell>
                      </TableRow>
                    ))}
                  </>
                )}
              </TableBody>
            </Table>
          )}
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Table size="small" className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>{i18n.t('DATE_KEY')}</TableCell>
                <TableCell>{i18n.t('TIME_KEY')}</TableCell>
                <TableCell>{i18n.t('TYPE_KEY')}</TableCell>
                <TableCell>{i18n.t('MESSAGE_KEY')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell align="center" colSpan={4}>
                  {i18n.t('ENVIRONMENTS_PAGE.NO_LOG_INSTANCE_KEY')}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TabPanel>
      </Grid>
      <Grid container justify="flex-end" className={classes.buttonsBase}>
        <Grid container className={classes.buttonsAlign}>
          <Button id="cancel-button" variant="outlined" onClick={modalClose}>
            {i18n.t('CANCEL_KEY')}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = ({
  environments: { isLoading, alarmsInstanceList },
  authenticate: { companySelected, data },
}: ApplicationState) => ({
  isLoading,
  alarmsInstanceList,
  companySelected,
  role: data?.role,
});

export default connect(mapStateToProps, {
  getAlarmsInstanceRequest,
})(AlarmesAndLogs);
